export const inputDebounce = 500;
export const settingsDebounce = 600;
export const lightsDebounce = 100; // Shorter debounce for color/brightness changes